import React from 'react';
import { cn } from '@/lib/core/utils';
import Navbar from '@/components/layout/Navbar';

interface KioskLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Full-screen layout optimized for tablet/kiosk devices
 * Uses the standard app Navbar for consistency
 */
export function KioskLayout({ children, className }: KioskLayoutProps) {
  return (
    <div
      className={cn(
        'min-h-screen w-full bg-gray-50 dark:bg-background',
        'flex flex-col',
        className
      )}
    >
      {/* Standard app navbar */}
      <Navbar hideBusinessNavigation={true} />

      {/* Main content area */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {children}
      </main>
    </div>
  );
}
